import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface UserCountByState {
	state: string;
	name: string;
	totalUsers: number;
}

export interface UserCountByStatesResponse {
	selectedStates: string[];
	totalUsers: number;
	states: UserCountByState[];
}

export const useGetUserCountByState = (states: string = '') => {
	return useQuery({
		queryKey: ['user-count-by-states', states],
		refetchInterval: 15_000,
		refetchIntervalInBackground: false,
		queryFn: async () => {
			const { data } = await api.get<UserCountByStatesResponse>('/user/countByStates', {
				params: { states: states || undefined },
			});
			return data;
		},
	});
};
